import { WbSunny, DarkMode } from '@mui/icons-material';

function ThemeToggle({ theme, onToggle }) {
  const isDark = theme === 'dark';
  return (
    <button
      type="button"
      className="theme-toggle"
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      onClick={onToggle}
    >
      {isDark ? <WbSunny /> : <DarkMode />}
    </button>
  );
}

export default ThemeToggle;
